var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeUpToFourHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#fe4d01",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18 6v1.091a.75.75 0 0 1-.298.596L12 12 6.3 7.725a.75.75 0 0 1-.3-.6V6h12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.25H6.75a1.5 1.5 0 0 0-1.5 1.5v3.375c.001.233.055.462.159.67s.255.389.441.53L10.75 12l-4.9 3.675c-.186.14-.337.321-.441.529s-.159.438-.159.671v3.375a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5v-3.341c0-.232-.055-.461-.158-.668s-.253-.389-.437-.529L13.244 12l4.911-3.712a1.51 1.51 0 0 0 .438-.529c.103-.208.157-.436.158-.668V3.75a1.5 1.5 0 0 0-1.5-1.5zm0 1.5v1.5H6.75v-1.5h10.5zm0 16.5H6.75v-3.375L12 12.938l5.25 3.97v3.342zM12 11.063L6.75 7.125V6.75h10.5v.341L12 11.063z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeUpToFourHours);
export default __webpack_public_path__ + "static/media/timeUpToFourHours.b83f938da79c43087696b30376d3c016.svg";
export { ForwardRef as ReactComponent };